<h1 mat-dialog-title>
  {{ data.title }}
  @if (data.closeButton) {
    <app-dialog-close mat-dialog-close></app-dialog-close>
  }
</h1>
<div mat-dialog-content>
  <markdown>{{ data.text }}</markdown>
</div>

<div mat-dialog-actions>
  @for (button of data.buttons; track button.text) {
    <button
      mat-stroked-button
      (click)="button.click()"
      [mat-dialog-close]="button.dialogResult"
    >
      {{ button.text }}
    </button>
  }
</div>
